import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { transformRichTextElementForApi } from './content-customization.transformers';
import type { ContentCustomizationCollection } from './content-customization.types';

export function contentCustomizationBackend(): Backend<ContentCustomizationCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUserId, ids, query, order) => ({
      endpoint: 'common/0.1/content_customizations/',
      params: {
        ids,
        entity_ids: getQueryParamValue(query, 'entityId'),
        injection_points: getQueryParamValue(query, 'injectionPoint'),
        language_codes: getQueryParamValue(query, 'languageCode'),
        entity_type: getQueryParamValue(query, 'entityType')[0],
      },
    }),
    push: undefined,
    set: undefined,
    update: (authUid, contentCustomization, originalContentCustomization) => {
      if (!contentCustomization.elements) {
        throw new Error(
          'Content customization update requires rich text elements',
        );
      }
      return {
        endpoint: `common/0.1/content_customization/${originalContentCustomization.id}`,
        method: 'PUT',
        payload: {
          elements: contentCustomization.elements.map(
            transformRichTextElementForApi,
          ),
        },
      };
    },
    remove: undefined,
  };
}
